import type { TOC } from '@ember/component/template-only'
import { ErrorsUnexpected } from 'teacher-ui-client/components/errors/unexpected'

interface Signature {
  Element: HTMLDivElement
}

/**
 * This should be rendered inside the subscription-type error substate, so subscription-type is known and nav rendered.
 */
export const ErrorsSubscriptionTypeErrorPage: TOC<Signature> = <template>
  <ErrorsUnexpected data-test-subscription-type-error class="mx-auto my-8 max-w-xl" ...attributes />
</template>

export default ErrorsSubscriptionTypeErrorPage
